/**
 * AWS credentials for S3 upload functionality
 * These are hardcoded for developer use
 */

export const AWS_ACCESS_KEY_ID = ''
export const AWS_SECRET_ACCESS_KEY = ''
export const AWS_SESSION_TOKEN = ''

export const AWS_REGION = 'eu-west-1'
export const AWS_S3_BUCKET_NAME = 'fh-affiliates-css'
